import api from "../api"

export async function getUsers(page = 1, limit = 50) {
  try {
    if (this.getState()['admin:users:loading']) return
    this.setState({ 'admin:users:loading': true })

    const response = await api.getUsers(page, limit)

    console.log(`getUsers(${page}, ${limit})`, response)

    this.setState({
      'admin:users': response.users,
      'admin:users:total': response.total,
      'admin:users:loading': false,
      'admin:users:error': null
    })

    return response
  } catch (error) {
    this.setState({
      'admin:users:loading': false,
      'admin:users:error': error
    })
    console.error('Failed to fetch users:', error)
    throw error
  }
}

export async function deleteUsers(userIds) {
  try {
    if (this.getState()['admin:users:deleting']) return
    this.setState({ 'admin:users:deleting': true })

    const response = await api.deleteUsers(userIds)

    this.setState({
      'admin:users:deleting': false
    })

    return response
  } catch (error) {
    this.setState({
      'admin:users:deleting': false
    })
    console.error('Failed to delete users:', error)
    throw error
  }
}
